import redux from '../redux';

describe('redux', () => {
  test('it should have proper object properties', () => {
    expect(redux).toHaveProperty('modal');
    expect(redux).toHaveProperty('bulkPauseUnpause');
    expect(redux).toHaveProperty('store');
    expect(redux).toHaveProperty('api');
    expect(redux.store).toHaveProperty('getState');
    expect(redux.store).toHaveProperty('dispatch');
  });
});
